import { listRulesData } from '@wix/ambassador-promote-accessibility-v1-accessibility-report/http';
const LIMIT = 100;
export const fetchRulesData = async httpClient => {
  const allRulesData = [];
  let cursor;
  try {
    do {
      var _paging$cursors;
      const {
        data: {
          paging,
          rulesData
        }
      } = await httpClient.request(listRulesData({
        cursor: {
          cursor,
          limit: LIMIT
        }
      }));
      allRulesData.push(...(rulesData ?? []));
      cursor = paging == null || (_paging$cursors = paging.cursors) == null ? void 0 : _paging$cursors.next;
    } while (cursor);
    return allRulesData;
  } catch (e) {
    return [];
  }
};
//# sourceMappingURL=fetch-rules-data.js.map